"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiKeyCreateApi = apiKeyCreateApi;
exports.apiKeyDeleteApi = apiKeyDeleteApi;
exports.apiKeyListApi = apiKeyListApi;
exports.apiKeyMasterApi = apiKeyMasterApi;
exports.apiKeyUpdateApi = apiKeyUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();
function apiKeyMasterApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.apiKey.master), params);
}
function apiKeyUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.UserService.apiKey.update), params);
}
function apiKeyListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.UserService.apiKey.list), params);
}
function apiKeyCreateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.UserService.apiKey.create), params);
}
function apiKeyDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.UserService.apiKey.delete), params);
}